export enum CourseType{
    GettingStarted=1,
    Core=2,
    General=3
}